
<template>
        <div style="background-color: #f8f8f8;padding-bottom: 248px;padding-top: 20px;">
            <div class="container " style="background-color: #fff;padding: 38px 50px;">
                <el-button type="text" link @click="$router.go(-1);" class="btnReturn " style="padding:0 0 38px 0;margin-left: 0;">
                 <div class="flx-center">
                    <img style="width: 18px;height: 18px;margin-right: 5px;" :src="$ossUrl+'icons/returnOrder.png'" alt=""/>
                    <span  style="color: black;font-size: 18px;line-height: 18px;">返回</span>
                 </div>
              </el-button>
              <div v-for="(item,index) in inviteList" :key="index" >
                <div v-if="item.id===id&&item.childrenId===childrenId">
                    <div class="invite-main-title">{{ item.main_title }}</div>
                    <div class="invite-main-content" v-for="(itemData,indexData) in item.main_content" :key="indexData">
                        <div class="invite-main-content-title">{{ itemData.title }}</div>
                        <div   v-for="(itemDetail,indexDetail) in itemData.content" :key="indexDetail">{{ itemDetail }}</div>
                    </div>
                    <!--简历投递邮箱：  -->
                    <div  class="invite-main-email">简历投递邮箱：<i v-html="item.main_email"></i></div>
                </div>
              </div>

              
            </div> 
          </div>
  </template>
  <script>
  export default {
    name:"inviteListDetail",
    components: {
     
      // Switcher
    },
    created() {
    console.log(this.$route.query.id)
    this.inviteData =JSON.parse( localStorage.getItem("inviteIndex") );

    if(this.inviteData){
      console.log(this.inviteData)
    }
    },
    data() {
      return {
        inviteData:{},
        id:this.$route.query.id,
        childrenId:this.$route.query.childrenId,
        inviteList: [
          { id:'9',childrenId:'1',main_title:"跨境物流销售",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、利用平台、网络、电话、网站等营销方法，开发对跨境电商物流或国际物流有需求的客户；',
                '2、合理利用和维护公司客户资源，通过各种途径开发新客户，为客户提供国际专线物流、跨境电商小包、海外仓储等服务；',
                '3、做好市场信息的收集，及时发现工作中的问题并反馈异常，跟进异常的处理结果；',
                '4、部门领导安排的其它临时性工作。 ',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、大专以上学历，专业不限；',
                '2、熟悉国际物流、货代或跨境电商行业，有出口国际空运、FBA跨境物流、国际物流小包或有FBA相关销售经验优先；',
                '3、积极热情，责任心强，良好的沟通协调能力及客户服务意识。',
                '4、对销售工作有兴趣的优秀应届生也可考虑。  ',
                '办公地点：深圳、东莞、广州、青岛、合肥、佛山、郑州、中山、上海、厦门、义乌 ',
              ]
            },
          ]},
          { id:'9',childrenId:'2',main_title:"业务助理",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责系统下单，跟进运单交期，物流跟踪情况及时向业务反馈情况。',
                '2、协助业务收集航班报表，发货进度表，及日常工作汇报情况日报、周报、月报。',
                '3、整理归类客户资料文件及合同文本存档流程，并做好保密工作。',
                '4、查看每天的出货情况，如货量有异常要及时找客户了解情况并反馈给领导。',
                '5、协助销售人员日常工作，衔接项目部、操作部、客服部处理客户的相关需求形成闭环。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、大专以上学历，英语四级以上水平；',
                '2、具有FBA物流行业操作客服经验，半年以上；',
                '3、能够熟练使用excel等办公软件，对数据较为敏感；',
                '办公地点：深圳',
              ]
            },
          ]},
          { id:'10',childrenId:'1',main_title:"港前客服",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、主要负责FBA空派，海派，铁路、卡航、快递等订单的跟进与处理；',
                '2、接收订单/指引下单/订单审核/提货/数据确认/船期确认/物流节点跟踪与反馈/问题件跟进与处理等事宜；',
                '3、了解公司产品与服务，及时为客户提供服务咨询及报价服务，解答客户疑问；',
                '4、与销售同事良好协作，配合销售同事需求，共同服务好客户；',
                '5、与相关部门进行工作协调，及时解决问题；',
                '6、维护好客户关系，增加黏性，提高货量；',
                '7、完成上级领导交代的其他工作。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、熟练使用办公软件操作；保证日常线上交流沟通；',
                '2、有半年/1年以上的FBA、FOB物流经验者优先；',
                '3、大专及以上学历，国际贸易，物流类相关专业优先；',
                '4、灵活，工作认真，细致，责任心强，具有较强的学习能力和服务意识；',
                '5、能承受一定的工作压力。',
                '办公地点：深圳、长沙',
              ]
            },
          ]},
          { id:'10',childrenId:'2',main_title:"客服助理",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、主要负责FBA空派，海派，铁路、卡航、快递等订单的跟进与处理；',
                '2、了解公司产品与服务，及时为客户提供服务咨询以及下单，解答客户疑问；',
                '3、物流单证(报关单，提单，签收单等)的跟进与处理；',
                '4、与相关部门进行工作协调，及时解决问题；',
                '5、完成上级领导交代的其他工作。'
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、熟练使用办公软件操作；保证日常线上交流沟通；',
                '2、本科及以上学历，国际贸易，物流类相关专业优先；',
                '3、工作认真，细致，责任心强，具有较强的学习能力和服务意识；',
                '4、能承受一定的工作压力。',
                '办公地点：长沙',
              ]
            },
          ]},
          { id:'5',childrenId:'1',main_title:"成本结算会计",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责收集、保管代理档案资料；',
                '2、负责与代理核对账单、申请付款、核销系统等工作；',
                '3、负责成本分摊与录入系统的工作；',
                '4、负责检查成本未出具的原因，跟进代理账单的提供；',
                '5、负责检查运单亏损的原因，提醒应收费用但未收的情况；',
                '6、负责部分异常费用录入应收的工作；',
                '7、配合应收、核算等岗位完成成本相关的工作；',
                '8、负责建立、健全代理应付台账明细；',
                '9、完成上级交待的其他工作。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、一年以上成本结算岗位的工作经验，熟练使用表格（表格使用为硬性要求）',
                '2、大专及以上学历',
                '3、具备强烈的责任心和认真细致的工作作风',
                '4、诚实、稳重、细心，有主动管理意识，沟通能力强、团队协作意识好',
                '5、有物流行业工作经验优先',
                '办公地点：长沙',
              ]
            },
          ]},
          { id:'5',childrenId:'2',main_title:"应收会计",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责应收账数据录入、检查、核对、统计工作；',
                '2、出具客户账单，并协助业务进行应收款项的催收；',
                '3、做好应收回款登记工作，并及时与各个客户进行应收款项的核对工作；',
                '4、做好应收账款分析工作，对异常情况、异常数据及时追踪处理，并及时上报。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、大专以上学历，财会相关专业毕业',
                '2、能够熟练使用Word、Excel等办公软件',
                '3、良好的口头及书面表达能力，较强的服务意识',
                '4、诚实敬业、细致严谨、责任心强、原则性强',
                '5、一年以上相关岗位工作经验',
                '办公地点：长沙',
              ]
            },
          ]},
          { id:'4',childrenId:'1',main_title:"产品经理（总监）",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、熟悉海运询价、订舱、操作、放货等全流程操作细节；',
                '2、熟悉澳大利亚航线的运价构成，了解船司和同行的报价规则，有较强的议价谈判能力；',
                '3、负责海运航线产品开发与优化，以及对供应商的管理（包括引进，考核与合同续签）；',
                '4、负责航线的价格收集与报价更新,提供特殊货物的询盘/舱位确认等；',
                '5、与海运船公司进行价格和舱位的谈判，签署合作协议；',
                '6、熟悉海运出口操作流程及相关海关条例，对海运出口业内市场行情熟悉；',
                '7、有船公司任职经验或者货代公司海运渠道/市场负责人经验，有带团队经验优先；',
                '8、推动产品落地，推进用户使用，根据产品反馈，定期进行产品回顾与优化。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、本科学历，英语4级以上,有国际快递或者跨境进出口行业经验，有电商经验优先考虑；',
                '2、5-10年同行业工作经验，熟悉国内市场及本行业海运市场行情，有一定船东和同行、客户资源；',
                '3、对市场价格敏感、市场洞察力强，沟通协作能力良好；',
                '4、跨境物流产品市场调研以及需求分析，跨境物流产品全链路设计与产品落地。',
                '5、制定产品方案，价格方案； 海外段供应商资源对接与协调；',
                '办公地点：深圳',
              ]
            },
          ]},
          { id:'4',childrenId:'2',main_title:"海运项目经理",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责美国海运航线产品开发与优化',
                '2、负责航线的价格收集与报价更新，为销售提供物流方案支持',
                '3、完成公司或上级领导交待的其它配合事宜',
                '4、协调各方资源处理突发问题',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、有传统货代商务/市场相关岗位2年以上工作经验或国际物流销售岗位2年以上经验；',
                '2、熟悉海运询价操作全流程细节，熟悉海运DDU/DDP全流程经验者优先；',
                '3、熟悉美线的运价构成，了解船司和同行的报价规则，有较强的议价谈判能力；',
                '4、对工作认真负责，有服务意识和团队精神；',
                '5、有较强抗压能力，良好的沟通能力。',
                '办公地点：深圳、广州、上海、义乌',
              ]
            },
          ]},
          { id:'2',childrenId:'1',main_title:"海运操作经理",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责熟悉海运清关-提柜-拆柜-派送等全链条港后工作的统筹、安排和分工；',
                '2、负责操作流程优化，成本控制，及供应商管理，结合各环节提高服务质量；',
                '3、把控业务流程中的关务风险，处理口岸清关、海关稽查等异常情况；',
                '4、定期汇总分析业务上出现的各类问题，并提出解决方案及建议；',
                '5、维护进出口通关的时间节点及合作方提供关键文件的时节点及相关异常处理（比如查验）；',
                '6、完成上级领导交办的其他工作；',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、本科及以上学历，3年及以上欧线全程操作经验，跨境物流行业优先；',
                '2、英语四级以上，熟悉欧美海运、物流及出口贸易基本知识；',
                '3、具备一定管理能力，能够妥善及时有效处理渠道各方面问题；',
                '4、具备良好的协调能力及沟通能力和良好的服务意识；',
                '办公地点：深圳',
              ]
            },
          ]},
          { id:'2',childrenId:'2',main_title:"海运操作",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责国际海运货物的操作、接收订单以及安排装柜、订舱、运输、货物跟踪、等事宜；',
                '2、协助海运操作人员完成包括审单、运单制作，信息录入；',
                '3、负责海运提单,提供海外代理补料文件及放货事宜；',
                '4、以及报关、清关文件的处理。',
                '5、跟进货物转运情况及与代理对接。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、大专及以上学历，2年以上货代操作文件工作经验；',
                '2、了解船司欧美线操作要求和流程；在海运货代庄家工作的经验；',
                '3、英语CET4级以上，有做海外操作文件经验；',
                '4、英语、德语、法语、西班牙语等会其中一种小语种优先。',
                '办公地点：深圳',
              ]
            },
          ]},
          { id:'3',childrenId:'1',main_title:"空运操作",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责国际空运货物的操作、接收订单以及安排订舱、运输、货物跟踪等事宜；',
                '2、制作空运订舱单，安排货件报关过港，与航空公司或代理订舱；',
                '3、以及报关、清关文件的处理；',
                '4、跟进货物转运情况及与代理对接。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、本科及以上学历，进出口贸易、物流等相关专业优先，应届毕生亦可；',
                '2、通过学习，熟悉空运操作流程，掌握了解空运市场价格以及航线知识；',
                '3、工作细心、责任心强，具有较强的服务意识和团队精神。',
                '办公地点：深圳',
              ]
            },
          ]},
          { id:'3',childrenId:'2',main_title:"2022-2024届本科生（储备干部方向）",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责跨境电商物流客服、报关、海/空运操作、销售、行政人事、财务等工作；',
                '2、与相关部门进行工作协调，及时解决问题；',
                '3、完成上级领导交代的其他工作。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、本科及以上学历，国际贸易，物流管理相关专业优先；',
                '2、在校期间学习认真、班级排名前15名，担任班级干部优先考虑；',
                '3、培养方向：客服、销售、项目、行政人事、财务等发展方向；',
                '4、熟练使用办公软件操作，保证日常线上交流沟通；',
                '办公地点：深圳、长沙',
              ]
            },
          ]},
          { id:'8',childrenId:'1',main_title:"海外仓客服经理",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、业务跟进：负责跟进海外仓相关业务，如收货、库存管理、退货换标、一件代发以及FBA中转等操作。需要确保业务流程顺畅，并及时更新与客户共享信息。',
                '2、客户沟通：与货代公司、仓库操作人员以及客户保持良好的沟通，确保服务的及时性和准确性。对于客户的咨询和问题要能够快速且准确地回应和处理。',
                '3、数据管理：负责收集和整理各种单证，完成送货单、订单、提单核对等工作，并进行基础数据录入和归档。同时要跟踪货物的送货情况，统计和核对相关数据。',
                '4、销售推广：熟悉掌握公司海外仓储业务的优势特点，面向跨境电商平台卖家进行推广及销售，通过多种渠道开发新的潜在客户，并维护好现有客户关系。',
                '5、异常处理：在货物运送到海外仓后，负责相关的安排及协调工作，如贴标、换标工作、运费确认等。同时要及时处理海外仓的异常反馈。',
                '6、财务管理：负责录入海外仓账单，并及时向客户收款，确保财务流程的正确性和及时性。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、本科以上学历，物流/贸易相关专业更佳；',
                '2、3年以上客服工作经验，2年以上客服团队管理经验，超过5人以上的客服团队的管理经验优先；',
                '3、有电商物流、国际物流或海外仓储及大型公司客服管理相关业务操作工作经验优先；',
                '4、有以客户为中心的意识，富有责任心，工作积极主动，具有信息整合能力，学习能力佳；',
                '5、细心、周到、思维敏捷，沟通灵活，有良好的执行力和团队合作精神；',
                '6、具较强的抗压能力和协调及解决问题的能力。',
                '办公地点：深圳',
              ]
            },
          ]},
          { id:'8',childrenId:'2',main_title:"系统运维专员",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责公司内部数据库、网站的管理及维护，主要是WMS/TMS海外仓储系统；',
                '2、负责网络及办公环境的维护、管理、故障排除等日常工作；',
                '3、维护数据中心，对系统数据进行备份。',
                '4、负责在微信工作群回复客户关于系统操作的问题，故障排除 ；',
                '5、上级交办的其他事宜。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、熟悉信息化系统，熟悉海外仓储系统，对流程开发及优化有成熟的经验（工作内容无需写代码，只需要与公司对接系统的需求即可），有相关海外仓系统经验者优先；',
                '2、熟悉和掌握各种计算机软硬件，可进行安装、调试及故障排除；',
                '3、具有较强的数据和信息的敏感性，具备较强的逻辑思维能力、数据分析能力和创新意识，能够独立解决问题；',
                '4、具有较强的组织沟通能力。',
                '办公地点：深圳',
              ]
            },
          ]},
          { id:'8',childrenId:'3',main_title:"海外仓质控",main_email:'深圳叶小姐：13018411767。邮箱：2420125231@qq.com；  长沙曾小姐：18274875843。邮箱：changshahr@szaaf.com',main_content:[
            {
              title:'岗位职责：',
              content:[
                '1、负责对海外仓库中的货物进行质量监控，确保存储的商品符合质量标准。这包括对商品的质量进行检查，以及对可能出现的质量问题进行及时的异常处理；',
                '2、负责对订单发货过程进行质量控制检查，确保发货的准确性和及时性，同时追踪客户反馈，以保证客户满意度；',
                '3、协助部门主管制定和完善相关的品质管理制度与措施，并督促这些制度的实施，以提高整个海外仓的质量管理效率；',
                '4、跟进仓储、运输、配送等环节的关键性能指标，并对异常数据进行处理和分析，以优化运营流程；',
                '5、负责汇总运营质量监控数据，并制作相关报表反馈给管理层，以便及时了解运营状况并作出决策；',
                '6、接收并统计内外部客户对运营环节的投诉，按月进行汇总分析，以改进服务质量。',
              ]
            },
            {
              title:'任职要求',
              content:[
                '1、本科以上学历，3年以上仓储/流行业经验；',
                '2、熟悉仓储运作流程（ToB ToC电商仓）、物流质量标准、流程优化；',
                '4、具有较强的组织沟通能力。',
                '办公地点：深圳',
              ]
            },
          ]},
      ]
      }
    },
    methods: {
      
    }
    
  };
  </script>
  <style src="../index.css" scoped>


  
  
  
  
  </style>